import { render, staticRenderFns } from "./DataBand.vue?vue&type=template&id=39fe200e&"
import script from "./DataBand.vue?vue&type=script&lang=js&"
export * from "./DataBand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports